module.exports = __webpack_public_path__ + "assets/img/05b7e1a7463169d0d3cbec06389a6d57.svg";